// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
	height: 100%;
	width: 100%;
}
body {
	background: none repeat 0 0 #f6f6f6;
	color: #000000;
	font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
	height: 100%;
	margin: 0;
	padding: 0;
}
form {
	margin: 0;
	padding: 0;
}
a {
	color: #2067b0;
	text-decoration: none;
	transition: border-bottom-color 0.2s linear;
}
a:hover {
	color: #2067b0;
	text-decoration: none;
}
h1 {
	color: #555555;
	font-size: 30px;
	font-weight: normal;
	margin: 0;
	padding: 0;
	text-shadow: 0 1px 0 #ffffff;
}
img {
	border: medium none;
}
#box-container {
	display: table;
	margin-top: 0px; 
	position: relative;
}
.div-last-year{
    color: #000099; 
    font-size: 10px; 
    display: block; 
    margin-top: 3px;
}
.menu-group-report:hover{
    background-color: #ddd;
}
#menu-group-active{
    width: auto !important;
    padding: 0 11px;
    margin-left: -11px;
    background-color: #717a84 !important;
    border-radius: 13px;
    color: #fff;
    padding-top: 7px;
    padding-bottom: 7px;
    font-weight: bold;
}
.link-favourite-rep{
    font-size: 14px;
    line-height: 60px;
    padding: 0 20px;
    -webkit-user-select: none;
            user-select: none;
    text-decoration: none;
    cursor: pointer;
}
.text-favourite-report{
    font-weight: bold;
    display: inline-block;
    height: 59px;
    color: #656a72;
}
.text-favourite-report:hover{
    color: #222529;
}
.text-favourite-report-active{
    font-weight: bold;
    display: inline-block;
    height: 59px;
    color: #205bbe;
    border-bottom: 1px solid #205bbe;
}
#more-favourite-report{
    color: #656a72;
    background: none;
}
#more-favourite-report:hover{
    color: #205bbe;
    background: #f5f3f3;
}
.more-favourite-arrow-down{
    border: solid #222529;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}
.link-popup-favourite-report{
    display: block;
    margin: 20px 0;
    color: #66696d;
    text-decoration: none;
    font-weight: bold;
    font-size: 12px;
}
.link-popup-favourite-report:hover{
    color: #000;
    text-decoration: none;
}
.link-popup-favourite-report-active{
    display: block;
    margin: 20px 0;
    color: #205bbe;
    text-decoration: underline;
    font-weight: bold;
    font-size: 12px;
}
.sub-menu-report:hover{
    background-color: #f1f1f1;
}
.link-report:hover{
    border: 2px solid #89e3f1;
}
.head-list-search-report:hover{
    background-color: #f1f1f1;
}
.sub-list-search-report:hover{
    background-color: #f1f1f1;
}
.close-icon{
  display:block;
  box-sizing:border-box;
  width:13px;
  height:13px;
  border-width:5px;
  border-color:none;
  border-radius:0px;
  background: -webkit-linear-gradient(-45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%), -webkit-linear-gradient(45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%);
  background-color:none;
  box-shadow:0px 0px 0px 0px rgba(0,0,0,0.5);
  transition: all 0.3s ease;
}
.tab-top-menu{
    background-color: #a79f9f;
    color: #fff;
    border: 1px solid #cab9b9;
}
.tab-top-menu-active{
    background: #fff;
    color: #928a8a;
}
.tab-top-menu:hover{
    background: #dcd6d6;
    color: #928a8a;
}
.submit-button {
    font-family: 'OpenSans-Bold', Helvetica, Arial, sans-serif;
    /*linear-gradient(to bottom, #ffffff 5%, #f6f6f6 100%);*/
    background-color: #ffffff;
    border-radius: 6px;
    border: 1px solid #d2c4c4;
    display: inline-block;
    cursor: pointer;
    color: #4f4f4f;
    font-family: Arial;
    font-size: 15px;
    font-weight: bold;
    padding: 12px 15px;
    text-decoration: none;
}
.submit-button:hover {
    background-color: #a2ebf7;
}
.option-filter{
    background-color: #fff;
}
.option-filter:hover{
    background-color: #f3f0f0;
}
.arrow-down{
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}
.small-close-icon {
    display:block;
    box-sizing:border-box;
    width:10px;
    height:8px;
    border-width:8px;
    border-color:none;
    border-radius:0px;
    background: -webkit-linear-gradient(-45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%), -webkit-linear-gradient(45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%);
    background-color:none;
    box-shadow:0px 0px 0px 0px rgba(0,0,0,0.5);
    transition: all 0.3s ease;
}
.small-close-icon-big {
    display:block;
    box-sizing:border-box;
    width:12px;
    height:11px;
    border-width:5px;
    border-color:none;
    border-radius:0px;
    background: -webkit-linear-gradient(-45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%), -webkit-linear-gradient(45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%);
    background-color:none;
    box-shadow:0px 0px 0px 0px rgba(0,0,0,0.5);
    transition: all 0.3s ease;
    cursor: pointer;
}
.small-close-icon-big:hover{
    background: -webkit-linear-gradient(-45deg, transparent 0%, transparent 46%, #12b1e3 46%,  #12b1e3 56%,transparent 56%, transparent 100%), -webkit-linear-gradient(45deg, transparent 0%, transparent 46%, #12b1e3 46%,  #12b1e3 56%,transparent 56%, transparent 100%);
}
.li-option-filter{
    background-color: #fff;
}
.li-option-filter:hover{
    background-color: #f5f5f5;
}
.btn-blue{
    box-sizing: border-box;
    margin: 0;
    outline: none;
    border: 1px solid #2fac88;
    background-color: #4DBE9D;
    cursor: pointer;
    transition: 160ms background-color linear, 160ms color linear, 160ms opacity linear, 160ms border-color linear;
    font: 12px 'OpenSans-SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 10px 20px;
    color: #fff;
    vertical-align: middle;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    border-radius: 2px;
}
.btn-blue:hover{
    background-color: #278167;
}
.btn-green{
    box-sizing: border-box;
    margin: 0;
    outline: none;
    border: 1px solid #b2e232;
    background-color: #b2e232;
    cursor: pointer;
    transition: 160ms background-color linear, 160ms color linear, 160ms opacity linear, 160ms border-color linear;
    font: 12px 'OpenSans-SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 10px 20px;
    color: #535c69;
    vertical-align: middle;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    border-radius: 2px;
}
.btn-green:hover{
    background-color: #c6ef5c;
    border: 1px solid #c3f149;
}
.btn-grey{
    box-sizing: border-box;
    margin: 0;
    outline: none;
    border: 1px solid #9fa4ab;
    background-color: #fff;
    cursor: pointer;
    transition: 160ms background-color linear, 160ms color linear, 160ms opacity linear, 160ms border-color linear;
    font: 12px 'OpenSans-SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 10px 20px;
    color: #535c69;
    vertical-align: middle;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    border-radius: 2px;
}
.btn-grey:hover{
    background-color: #cbced2;
    border: 1px solid #dde2e5;
}
#btn-expand-menu{
    width: 17px;
    height: 43px;
    background: #3bc8f5;
    position: absolute;
    top: 12px;
    z-index: 1002;
    right: -8px;
    cursor: pointer;
    border-radius: 12px;
}
#btn-expand-menu:hover{
    background: #3eddff;
}
#btn-expand-arrow-left{
    border: solid #fff;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    margin-top: 17px;
    margin-left: 6px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
}
#btn-expand-arrow-right{
    border: solid #fff;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    margin-top: 17px;
    margin-left: 2px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}
.btn-more-expend{
    box-sizing: border-box;
    margin: 0;
    outline: none;
    border: 1px solid #2fac88;
    background-color: #4DBE9D;
    cursor: pointer;
    transition: 160ms background-color linear, 160ms color linear, 160ms opacity linear, 160ms border-color linear;
    font: 10px 'OpenSans-SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 6px 8px;
    color: #fff;
    vertical-align: middle;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    border-radius: 50px;
}
.btn-more-expend:hover{
    background-color: #278167;
}
.setting-filter{
    opacity: 0.7;
}
.setting-filter:hover{
    opacity: 1;
}
.plus-icon {
    width: 10px;
    height: 10px;
    position: absolute;
    top: 0;
    left: 0;
}
.plus-icon:after {
    background-color: #8e8a8a;
    width: 10px;
    height: 2px;
    position: absolute;
    top: 4px;
    left: 0px;
    content: '';
}
.plus-icon:before {
    background-color: #8e8a8a;
    width: 2px;
    height: 10px;
    position: absolute;
    top: 0px;
    left: 4px;
    content: '';
}
.blue-button{
    float: left;
    width: 100%;
    background-color: #12b1e3;
    color: #fff;
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    padding: 0 19px;
    height: 42px;
    outline: none;
    border: none;
    border-radius: 2px;
    vertical-align: middle;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    font: 600 12px/42px 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    cursor: pointer;
    transition: 160ms color linear, 160ms background-color linear, 160ms opacity linear, 160ms padding linear;
}
.blue-button:hover {
    background-color: #3eddff;
}
#menu-outer-option-filter{
    z-index: 1000;
    position: absolute;
    top: 50px;
    background-color: #fff;
    box-shadow: 0 7px 21px rgba(83, 92, 105, .12), 0 -1px 6px 0 rgba(83, 92, 105, .06);
    font: 13px 'Helvetica Neue', Helvetica, Arial, sans-serif;
    width: 100%;
    padding: 10px 0;
}
.menu-sub-option-filter{
    float: left;
    width: 100%;
    cursor: pointer;
}
.menu-sub-option-filter:hover {
    background-color: #f6f8f9;
}
.link-menu-sub-option-filter{
    padding: 0 15px;
    display: inline-block;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    color: #525c68;
    line-height: 36px;
    padding: 0 15px 0 9px;
    text-decoration: none;
    vertical-align: middle;
    transition: color 0.2s linear;
}
.link-menu-sub-option-filter:hover{
    text-decoration: none;
}
/* POPUP ALERT */
.popup-overlay {
    position: fixed;
    width: 100%;
    top: 0px;
    margin: 0px;
    min-height: 200px;
    height: 100%;
    background-color: #000;
    z-index: 1003;
    opacity: 0.7;
    display: none;
}
.popup-innerhtml {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 1600px;
    min-height: 200px;
    padding-top: 20px;
    background-color: #FFF;
    border: 2px solid #CCC;
    z-index: 1003;
    box-shadow: #000 0 2px 18px;
    display: none;
}
.popup-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background: red;
    cursor: pointer;
}
.popup-close:after {
    content: '';
    height: 16px;
    border-left: 2px solid #fff;
    position: absolute;
    transform: rotate(45deg);
    left: 9px;
    top: 2px;
}
.popup-close:before {
    content: '';
    height: 16px;
    border-left: 2px solid #fff;
    position: absolute;
    transform: rotate(-45deg);
    left: 9px;
    top: 2px;
}
.popup-content{
    float: left;
    overflow: auto;
    width: 100%;
    min-height: 200px;
}
.popup-inner-content{
    padding: 15px;
    display: block;
}
/* END POPUP ALERT */
/* SMALL POPUP ALERT */
.small-popup-overlay {
    position: fixed;
    width: 100%;
    top: 0px;
    margin: 0px;
    min-height: 200px;
    height: 100%;
    background-color: #000;
    z-index: 1003;
    opacity: 0.7;
    display: none;
}
.small-popup-innerhtml {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    background-color: #FFF;
    border: 1px solid #CCC;
    z-index: 1003;
    box-shadow: #000 0 2px 18px;
    border-radius: 8px;
    display: none;
    overflow: hidden;
}
.small-popup-close {
    position: absolute;
    top: 7px;
    right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.small-popup-close:after {
    content: '';
    height: 16px;
    border-left: 3px solid #fff;
    position: absolute;
    transform: rotate(45deg);
    left: 9px;
    top: 2px;
    border-radius: 18%;
}
.small-popup-close:before {
    content: '';
    height: 16px;
    border-left: 3px solid #fff;
    position: absolute;
    transform: rotate(-45deg);
    left: 9px;
    top: 2px;
    border-radius: 18%;
}
.small-popup-close:hover::after,
.small-popup-close:hover::before {
    border-color: red;
}
.small-popup-content{
    float: left;
    overflow: auto;
    width: 100%;
}
.small-popup-inner-content{
    padding: 15px;
    display: block;
    position: relative;
}
.small-popup-title{
    display: block;
    height: 35px;
    background: #4DBE9D;
    border-radius: 5px;
}
.small-popup-title-span{
    float: left;
    margin-left: 15px;
    margin-right: 15px;
    color: #fff;
    font-size: 16px;
    line-height: 35px;
}
/* END SMALL POPUP ALERT */
.loading-overlay {
    position: fixed;
    width: 100%;
    top: 0px;
    margin: 0px;
    min-height: 200px;
    height: 100%;
    background-color: #000;
    z-index: 1004;
    opacity: 0.4;
}
.loading-image {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
    z-index: 1005;
}
.loading-text {
    position: absolute;
    bottom: 11px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
}
.loading-overlay-total-sales {
    position: absolute;
    width: 100%;
    top: 0px;
    margin: 0px;
    min-height: 200px;
    height: 100%;
    background-color: #000;
    z-index: 1;
    opacity: 0.4;
    border-radius: 0px 0px 6px 6px;
}
.loading-image-total-sales {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
    z-index: 2;
}
.head-link-is-favourite{
    color: #0070BA;
}
.head-link-is-not-favourite{
    color: #000;
}
.link-is-favourite{
    color: #0070BA;
}
.link-is-not-favourite{
    color: #535c69;
}
.warning-required-filter-search{
    margin-left: 10px;
    font-size: 12px;
    color: red;
}
.select-page-report{
    color: #0070BA;
    font-size: 12px;
    text-decoration: none;
    font-weight: bold;
}
.select-page-text{
    color: #0070BA;
    font-size: 11px;
    text-decoration: none;
    font-weight: bold;
}
.select-page-arrow {
    border: solid #0070BA;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    width: 1px;
    height: 1px;
}
.select-page-arrow-right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}
.select-page-arrow-left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
}
.select-page-arrow-up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
}
.select-page-arrow-down {
    border: solid #7c7373;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}
.li-option-select-row{
    background-color: #fff;
}
.li-option-select-row:hover{
    background-color: #f5f5f5;
}
.tb-admin-report{
    border: 0px solid #ddd;
}
.tb-admin-report th{
    border: 1px solid #ddd;
    padding: 8px 8px;
    font-weight: bold;
    background: #ddd;
    min-width: 50px;
    font-size: 12px;
}
.tb-admin-report td{
    font-size: 12px;
    padding: 10px 15px;
    border: 1px solid #ddd;
}
.box-suggest{
    width: 250px;
    border: 1px solid #adaaaa;
    position: relative;
    margin-left: 28px;
    margin-right: 20px;
    margin-top: 25px;
    float: left;
}
.readmore-suggest, .hidden-suggest{
    color: #1f95e2;
}
.readmore-report, .hidden-report{
    color: #1f95e2;
}
.slidebar-widget{
    float: left;
    width: 100%;
    background: #fff;
}
.slidebar-widget-top{
    margin-bottom: 10px;
    position: relative;
}
.slidebar-widget-top-title{
    color: #fff;
    font-family: \\"OpenSans-Bold\\", sans-serif;
    font-size: 12px;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    text-transform: uppercase;
    font-weight: bold;
}
.slidebar-widget-top-add{
    position: absolute;
    right: 10px;
    top: 9px;
    font-size: 17px;
}
.slidebar-widget-content{
    display: block;
}
.slidebar-widget-item{
    border-bottom: none;
    display: block;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 3px;
    overflow: hidden;
    padding: 8px 0 8px 17px;
}
.inside-sub-menu-report a{
    text-decoration: none;
    display: block;
    font-size: 14px;
    color: #8a8f96;
}
::-webkit-scrollbar {
    width: 12px;
    cursor: pointer;
    height: 12px;
}
::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
}
.text-red{
    color: #ff0000;
}
.group-list-search-report{
    list-style: none outside none;
    margin: 0px 0px;
    padding: 0;
    position: relative;
    page-break-inside: avoid;
    break-inside: avoid-column;
    max-width: 300px;
    width: 300px;
    display: inline-table;
}
.select-filter{
    background-color: #fff;
    color: #000;
}
.inp-disable{
    background-color: #e8e8e0;
    color: #5f5a5a;
}
.inp-link-disable{
    display: none;
}
.dropup-btn {
    background-color: #fff;
    color: #665757;
    padding: 9px 14px;
    font-size: 13px;
    border: none;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
}

.dropup {
    position: relative;
    display: inline-block;
}

.dropup-content {
    display: none;
    position: absolute;
    background-color: #fff;
    min-width: 160px;
    bottom: 50px;
    z-index: 1;
    box-shadow: -1px 4px 6px 2px #ddd;
}

.dropup-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    font-size: 12px;
}

.dropup-content a:hover {
    background-color: #fafafa;
}

/*.dropup:hover .dropup-content {
    display: block;
}*/

/*.dropup:hover .dropup-btn {
    border: 1px solid #000;
    color: #000;
}*/
.circle{
    border: 2px solid #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    background: none;
}
.circle:hover{
    background: #fff;
}
.circle:active{
    background: #fff;
}
.circle:before,
.circle:after{
    content:'';position:absolute;top:0;left:0;right:0;bottom:0;
}
/* PLUS */
.circle.plus:before,
.circle.plus:after {
    background: #fff;
}
.circle.plus:hover::before,
.circle.plus:hover::after {
    background: #2fc7f7;
}
.circle.plus:before{
    width: 2px;
    margin: 3px auto;
}
.circle.plus:after{
    margin: auto 3px;
    height: 2px;
    box-shadow: none;
}
.percentdiff-up{
    color: #009900;
}
.percentdiff-down{
    color: #ff0000;
}
.hidden{
    display: none;
}
.tb-report{
    border: 1px solid #ddf;
}
.tb-report th{
    border: 1px solid #ddf;
    padding: 5px 3px;
    font-weight: bold;
    background: #DCE6F1;
    min-width: 50px;
    font-size: 12px;
}
.tb-report td{
    border: 1px solid #ddf;
    padding: 5px 3px;
}
/* The container */
.checkbox-container {
    float: left;
    position: relative;
    padding-left: 25px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    user-select: none;
    line-height: 19px;
  }
/* Hide the browser's default checkbox */
.checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  
  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    background-color: #f1f1f1;
    border: 1px solid #8e8a8a;
  }
  
  /* On mouse-over, add a grey background color */
  .checkbox-container:hover input ~ .checkmark {
    background-color: #ccc;
  }
  
  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkmark {
    background-color: #4DBE9D/*#2196F3*/;
    border: 1px solid #fff;
  }
  
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  /* Show the checkmark when checked */
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  /* Style the checkmark/indicator */
  .checkbox-container .checkmark:after {
    left: 5px;
    top: 1px;
    width: 3px;
    height: 9px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }

  input:focus {
    outline:none;
    border: 1px solid red;
  }
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,WAAW;AACZ;AACA;CACC,mCAAmC;CACnC,cAAc;CACd,wDAAwD;CACxD,eAAe;CACf,mCAAmC;CACnC,YAAY;CACZ,SAAS;CACT,UAAU;AACX;AACA;CACC,SAAS;CACT,UAAU;AACX;AACA;CACC,cAAc;CACd,qBAAqB;CAGrB,2CAA2C;AAC5C;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,SAAS;CACT,UAAU;CACV,4BAA4B;AAC7B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uQAAuQ;EACvQ,qBAAqB;EACrB,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,0DAA0D;IAC1D,wDAAwD;IACxD,yBAAyB;IAGzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uQAAuQ;IACvQ,qBAAqB;IACrB,0CAA0C;IAC1C,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uQAAuQ;IACvQ,qBAAqB;IACrB,0CAA0C;IAC1C,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,uQAAuQ;AAC3Q;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,8GAA8G;IAC9G,8EAA8E;IAC9E,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,8GAA8G;IAC9G,8EAA8E;IAC9E,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,8GAA8G;IAC9G,8EAA8E;IAC9E,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,8GAA8G;IAC9G,8EAA8E;IAC9E,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,+EAA+E;IAC/E,eAAe;IACf,yGAAyG;AAC7G;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,kFAAkF;IAClF,yDAAyD;IACzD,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,2DAA2D;IAC3D,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IAEtB,6BAA6B;AACjC;AACA;IACI,qBAAqB;AACzB;AACA,gBAAgB;AAChB;IACI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;AACA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IAIR,gCAAgC;IAChC,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,QAAQ;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,QAAQ;AACZ;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA,oBAAoB;AACpB,sBAAsB;AACtB;IACI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;AACA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IAIR,gCAAgC;IAChC,UAAU;IACV,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AACA,0BAA0B;AAC1B;IACI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;AACA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IAIR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IAIR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,UAAU;AACd;AACA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,UAAU;IACV,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,0CAA0C;IAC1C,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;AACA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,eAAe;IACf,UAAU;IACV,kBAAkB;IAElB,wBAAwB;IACxB,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;EAEE;;AAEF;;;EAGE;AACF;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,UAAU,CAAC,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,OAAO,CAAC,QAAQ;AAC9D;AACA,SAAS;AACT;;IAEI,gBAAgB;AACpB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA,kBAAkB;AAClB;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;IACjB,iBAAiB;EACnB;AACF,wCAAwC;AACxC;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;EACV;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA,+CAA+C;EAC/C;IACE,sBAAsB;EACxB;;EAEA,wDAAwD;EACxD;IACE,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA,6DAA6D;EAC7D;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA,oCAAoC;EACpC;IACE,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IAGzB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB","sourcesContent":["html {\r\n\theight: 100%;\r\n\twidth: 100%;\r\n}\r\nbody {\r\n\tbackground: none repeat 0 0 #f6f6f6;\r\n\tcolor: #000000;\r\n\tfont-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n\tfont-size: 14px;\r\n\t-webkit-font-smoothing: antialiased;\r\n\theight: 100%;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\nform {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\na {\r\n\tcolor: #2067b0;\r\n\ttext-decoration: none;\r\n\r\n\t-webkit-transition: border-bottom-color 0.2s linear;\r\n\ttransition: border-bottom-color 0.2s linear;\r\n}\r\na:hover {\r\n\tcolor: #2067b0;\r\n\ttext-decoration: none;\r\n}\r\nh1 {\r\n\tcolor: #555555;\r\n\tfont-size: 30px;\r\n\tfont-weight: normal;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\ttext-shadow: 0 1px 0 #ffffff;\r\n}\r\nimg {\r\n\tborder: medium none;\r\n}\r\n#box-container {\r\n\tdisplay: table;\r\n\tmargin-top: 0px; \r\n\tposition: relative;\r\n}\r\n.div-last-year{\r\n    color: #000099; \r\n    font-size: 10px; \r\n    display: block; \r\n    margin-top: 3px;\r\n}\r\n.menu-group-report:hover{\r\n    background-color: #ddd;\r\n}\r\n#menu-group-active{\r\n    width: auto !important;\r\n    padding: 0 11px;\r\n    margin-left: -11px;\r\n    background-color: #717a84 !important;\r\n    border-radius: 13px;\r\n    color: #fff;\r\n    padding-top: 7px;\r\n    padding-bottom: 7px;\r\n    font-weight: bold;\r\n}\r\n.link-favourite-rep{\r\n    font-size: 14px;\r\n    line-height: 60px;\r\n    padding: 0 20px;\r\n    user-select: none;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n.text-favourite-report{\r\n    font-weight: bold;\r\n    display: inline-block;\r\n    height: 59px;\r\n    color: #656a72;\r\n}\r\n.text-favourite-report:hover{\r\n    color: #222529;\r\n}\r\n.text-favourite-report-active{\r\n    font-weight: bold;\r\n    display: inline-block;\r\n    height: 59px;\r\n    color: #205bbe;\r\n    border-bottom: 1px solid #205bbe;\r\n}\r\n#more-favourite-report{\r\n    color: #656a72;\r\n    background: none;\r\n}\r\n#more-favourite-report:hover{\r\n    color: #205bbe;\r\n    background: #f5f3f3;\r\n}\r\n.more-favourite-arrow-down{\r\n    border: solid #222529;\r\n    border-width: 0 1px 1px 0;\r\n    display: inline-block;\r\n    padding: 3px;\r\n    transform: rotate(45deg);\r\n    -webkit-transform: rotate(45deg);\r\n}\r\n.link-popup-favourite-report{\r\n    display: block;\r\n    margin: 20px 0;\r\n    color: #66696d;\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n}\r\n.link-popup-favourite-report:hover{\r\n    color: #000;\r\n    text-decoration: none;\r\n}\r\n.link-popup-favourite-report-active{\r\n    display: block;\r\n    margin: 20px 0;\r\n    color: #205bbe;\r\n    text-decoration: underline;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n}\r\n.sub-menu-report:hover{\r\n    background-color: #f1f1f1;\r\n}\r\n.link-report:hover{\r\n    border: 2px solid #89e3f1;\r\n}\r\n.head-list-search-report:hover{\r\n    background-color: #f1f1f1;\r\n}\r\n.sub-list-search-report:hover{\r\n    background-color: #f1f1f1;\r\n}\r\n.close-icon{\r\n  display:block;\r\n  box-sizing:border-box;\r\n  width:13px;\r\n  height:13px;\r\n  border-width:5px;\r\n  border-color:none;\r\n  border-radius:0px;\r\n  background: -webkit-linear-gradient(-45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%), -webkit-linear-gradient(45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%);\r\n  background-color:none;\r\n  box-shadow:0px 0px 0px 0px rgba(0,0,0,0.5);\r\n  transition: all 0.3s ease;\r\n}\r\n.tab-top-menu{\r\n    background-color: #a79f9f;\r\n    color: #fff;\r\n    border: 1px solid #cab9b9;\r\n}\r\n.tab-top-menu-active{\r\n    background: #fff;\r\n    color: #928a8a;\r\n}\r\n.tab-top-menu:hover{\r\n    background: #dcd6d6;\r\n    color: #928a8a;\r\n}\r\n.submit-button {\r\n    font-family: 'OpenSans-Bold', Helvetica, Arial, sans-serif;\r\n    /*linear-gradient(to bottom, #ffffff 5%, #f6f6f6 100%);*/\r\n    background-color: #ffffff;\r\n    -moz-border-radius: 6px;\r\n    -webkit-border-radius: 6px;\r\n    border-radius: 6px;\r\n    border: 1px solid #d2c4c4;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #4f4f4f;\r\n    font-family: Arial;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n    padding: 12px 15px;\r\n    text-decoration: none;\r\n}\r\n.submit-button:hover {\r\n    background-color: #a2ebf7;\r\n}\r\n.option-filter{\r\n    background-color: #fff;\r\n}\r\n.option-filter:hover{\r\n    background-color: #f3f0f0;\r\n}\r\n.arrow-down{\r\n    border: solid black;\r\n    border-width: 0 2px 2px 0;\r\n    display: inline-block;\r\n    padding: 3px;\r\n    transform: rotate(45deg);\r\n    -webkit-transform: rotate(45deg);\r\n}\r\n.small-close-icon {\r\n    display:block;\r\n    box-sizing:border-box;\r\n    width:10px;\r\n    height:8px;\r\n    border-width:8px;\r\n    border-color:none;\r\n    border-radius:0px;\r\n    background: -webkit-linear-gradient(-45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%), -webkit-linear-gradient(45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%);\r\n    background-color:none;\r\n    box-shadow:0px 0px 0px 0px rgba(0,0,0,0.5);\r\n    transition: all 0.3s ease;\r\n}\r\n.small-close-icon-big {\r\n    display:block;\r\n    box-sizing:border-box;\r\n    width:12px;\r\n    height:11px;\r\n    border-width:5px;\r\n    border-color:none;\r\n    border-radius:0px;\r\n    background: -webkit-linear-gradient(-45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%), -webkit-linear-gradient(45deg, transparent 0%, transparent 46%, #788089 46%,  #788089 56%,transparent 56%, transparent 100%);\r\n    background-color:none;\r\n    box-shadow:0px 0px 0px 0px rgba(0,0,0,0.5);\r\n    transition: all 0.3s ease;\r\n    cursor: pointer;\r\n}\r\n.small-close-icon-big:hover{\r\n    background: -webkit-linear-gradient(-45deg, transparent 0%, transparent 46%, #12b1e3 46%,  #12b1e3 56%,transparent 56%, transparent 100%), -webkit-linear-gradient(45deg, transparent 0%, transparent 46%, #12b1e3 46%,  #12b1e3 56%,transparent 56%, transparent 100%);\r\n}\r\n.li-option-filter{\r\n    background-color: #fff;\r\n}\r\n.li-option-filter:hover{\r\n    background-color: #f5f5f5;\r\n}\r\n.btn-blue{\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    outline: none;\r\n    border: 1px solid #2fac88;\r\n    background-color: #4DBE9D;\r\n    cursor: pointer;\r\n    transition: 160ms background-color linear, 160ms color linear, 160ms opacity linear, 160ms border-color linear;\r\n    font: 12px 'OpenSans-SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    padding: 10px 20px;\r\n    color: #fff;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    text-transform: uppercase;\r\n    white-space: nowrap;\r\n    border-radius: 2px;\r\n}\r\n.btn-blue:hover{\r\n    background-color: #278167;\r\n}\r\n.btn-green{\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    outline: none;\r\n    border: 1px solid #b2e232;\r\n    background-color: #b2e232;\r\n    cursor: pointer;\r\n    transition: 160ms background-color linear, 160ms color linear, 160ms opacity linear, 160ms border-color linear;\r\n    font: 12px 'OpenSans-SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    padding: 10px 20px;\r\n    color: #535c69;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    text-transform: uppercase;\r\n    white-space: nowrap;\r\n    border-radius: 2px;\r\n}\r\n.btn-green:hover{\r\n    background-color: #c6ef5c;\r\n    border: 1px solid #c3f149;\r\n}\r\n.btn-grey{\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    outline: none;\r\n    border: 1px solid #9fa4ab;\r\n    background-color: #fff;\r\n    cursor: pointer;\r\n    transition: 160ms background-color linear, 160ms color linear, 160ms opacity linear, 160ms border-color linear;\r\n    font: 12px 'OpenSans-SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    padding: 10px 20px;\r\n    color: #535c69;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    text-transform: uppercase;\r\n    white-space: nowrap;\r\n    border-radius: 2px;\r\n}\r\n.btn-grey:hover{\r\n    background-color: #cbced2;\r\n    border: 1px solid #dde2e5;\r\n}\r\n#btn-expand-menu{\r\n    width: 17px;\r\n    height: 43px;\r\n    background: #3bc8f5;\r\n    position: absolute;\r\n    top: 12px;\r\n    z-index: 1002;\r\n    right: -8px;\r\n    cursor: pointer;\r\n    border-radius: 12px;\r\n}\r\n#btn-expand-menu:hover{\r\n    background: #3eddff;\r\n}\r\n#btn-expand-arrow-left{\r\n    border: solid #fff;\r\n    border-width: 0 3px 3px 0;\r\n    display: inline-block;\r\n    padding: 3px;\r\n    margin-top: 17px;\r\n    margin-left: 6px;\r\n    transform: rotate(135deg);\r\n    -webkit-transform: rotate(135deg);\r\n}\r\n#btn-expand-arrow-right{\r\n    border: solid #fff;\r\n    border-width: 0 3px 3px 0;\r\n    display: inline-block;\r\n    padding: 3px;\r\n    margin-top: 17px;\r\n    margin-left: 2px;\r\n    transform: rotate(-45deg);\r\n    -webkit-transform: rotate(-45deg);\r\n}\r\n.btn-more-expend{\r\n    box-sizing: border-box;\r\n    margin: 0;\r\n    outline: none;\r\n    border: 1px solid #2fac88;\r\n    background-color: #4DBE9D;\r\n    cursor: pointer;\r\n    transition: 160ms background-color linear, 160ms color linear, 160ms opacity linear, 160ms border-color linear;\r\n    font: 10px 'OpenSans-SemiBold', 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    padding: 6px 8px;\r\n    color: #fff;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    text-transform: uppercase;\r\n    white-space: nowrap;\r\n    border-radius: 50px;\r\n}\r\n.btn-more-expend:hover{\r\n    background-color: #278167;\r\n}\r\n.setting-filter{\r\n    opacity: 0.7;\r\n}\r\n.setting-filter:hover{\r\n    opacity: 1;\r\n}\r\n.plus-icon {\r\n    width: 10px;\r\n    height: 10px;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n.plus-icon:after {\r\n    background-color: #8e8a8a;\r\n    width: 10px;\r\n    height: 2px;\r\n    position: absolute;\r\n    top: 4px;\r\n    left: 0px;\r\n    content: '';\r\n}\r\n.plus-icon:before {\r\n    background-color: #8e8a8a;\r\n    width: 2px;\r\n    height: 10px;\r\n    position: absolute;\r\n    top: 0px;\r\n    left: 4px;\r\n    content: '';\r\n}\r\n.blue-button{\r\n    float: left;\r\n    width: 100%;\r\n    background-color: #12b1e3;\r\n    color: #fff;\r\n    position: relative;\r\n    display: inline-block;\r\n    box-sizing: border-box;\r\n    padding: 0 19px;\r\n    height: 42px;\r\n    outline: none;\r\n    border: none;\r\n    border-radius: 2px;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    text-transform: uppercase;\r\n    font: 600 12px/42px 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    cursor: pointer;\r\n    transition: 160ms color linear, 160ms background-color linear, 160ms opacity linear, 160ms padding linear;\r\n}\r\n.blue-button:hover {\r\n    background-color: #3eddff;\r\n}\r\n#menu-outer-option-filter{\r\n    z-index: 1000;\r\n    position: absolute;\r\n    top: 50px;\r\n    background-color: #fff;\r\n    box-shadow: 0 7px 21px rgba(83, 92, 105, .12), 0 -1px 6px 0 rgba(83, 92, 105, .06);\r\n    font: 13px 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    width: 100%;\r\n    padding: 10px 0;\r\n}\r\n.menu-sub-option-filter{\r\n    float: left;\r\n    width: 100%;\r\n    cursor: pointer;\r\n}\r\n.menu-sub-option-filter:hover {\r\n    background-color: #f6f8f9;\r\n}\r\n.link-menu-sub-option-filter{\r\n    padding: 0 15px;\r\n    display: inline-block;\r\n    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    color: #525c68;\r\n    line-height: 36px;\r\n    padding: 0 15px 0 9px;\r\n    text-decoration: none;\r\n    vertical-align: middle;\r\n    -webkit-transition: color 0.2s linear;\r\n    transition: color 0.2s linear;\r\n}\r\n.link-menu-sub-option-filter:hover{\r\n    text-decoration: none;\r\n}\r\n/* POPUP ALERT */\r\n.popup-overlay {\r\n    position: fixed;\r\n    width: 100%;\r\n    top: 0px;\r\n    margin: 0px;\r\n    min-height: 200px;\r\n    height: 100%;\r\n    background-color: #000;\r\n    z-index: 1003;\r\n    opacity: 0.7;\r\n    display: none;\r\n}\r\n.popup-innerhtml {\r\n    position: fixed;\r\n    left: 50%;\r\n    top: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    -moz-transform: translate(-50%, -50%);\r\n    -webkit-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    width: 80%;\r\n    max-width: 1600px;\r\n    min-height: 200px;\r\n    padding-top: 20px;\r\n    background-color: #FFF;\r\n    border: 2px solid #CCC;\r\n    z-index: 1003;\r\n    box-shadow: #000 0 2px 18px;\r\n    display: none;\r\n}\r\n.popup-close {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    background: red;\r\n    cursor: pointer;\r\n}\r\n.popup-close:after {\r\n    content: '';\r\n    height: 16px;\r\n    border-left: 2px solid #fff;\r\n    position: absolute;\r\n    transform: rotate(45deg);\r\n    left: 9px;\r\n    top: 2px;\r\n}\r\n.popup-close:before {\r\n    content: '';\r\n    height: 16px;\r\n    border-left: 2px solid #fff;\r\n    position: absolute;\r\n    transform: rotate(-45deg);\r\n    left: 9px;\r\n    top: 2px;\r\n}\r\n.popup-content{\r\n    float: left;\r\n    overflow: auto;\r\n    width: 100%;\r\n    min-height: 200px;\r\n}\r\n.popup-inner-content{\r\n    padding: 15px;\r\n    display: block;\r\n}\r\n/* END POPUP ALERT */\r\n/* SMALL POPUP ALERT */\r\n.small-popup-overlay {\r\n    position: fixed;\r\n    width: 100%;\r\n    top: 0px;\r\n    margin: 0px;\r\n    min-height: 200px;\r\n    height: 100%;\r\n    background-color: #000;\r\n    z-index: 1003;\r\n    opacity: 0.7;\r\n    display: none;\r\n}\r\n.small-popup-innerhtml {\r\n    position: fixed;\r\n    left: 50%;\r\n    top: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    -moz-transform: translate(-50%, -50%);\r\n    -webkit-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    width: 80%;\r\n    background-color: #FFF;\r\n    border: 1px solid #CCC;\r\n    z-index: 1003;\r\n    box-shadow: #000 0 2px 18px;\r\n    border-radius: 8px;\r\n    display: none;\r\n    overflow: hidden;\r\n}\r\n.small-popup-close {\r\n    position: absolute;\r\n    top: 7px;\r\n    right: 10px;\r\n    width: 20px;\r\n    height: 20px;\r\n    cursor: pointer;\r\n}\r\n.small-popup-close:after {\r\n    content: '';\r\n    height: 16px;\r\n    border-left: 3px solid #fff;\r\n    position: absolute;\r\n    transform: rotate(45deg);\r\n    left: 9px;\r\n    top: 2px;\r\n    border-radius: 18%;\r\n}\r\n.small-popup-close:before {\r\n    content: '';\r\n    height: 16px;\r\n    border-left: 3px solid #fff;\r\n    position: absolute;\r\n    transform: rotate(-45deg);\r\n    left: 9px;\r\n    top: 2px;\r\n    border-radius: 18%;\r\n}\r\n.small-popup-close:hover::after,\r\n.small-popup-close:hover::before {\r\n    border-color: red;\r\n}\r\n.small-popup-content{\r\n    float: left;\r\n    overflow: auto;\r\n    width: 100%;\r\n}\r\n.small-popup-inner-content{\r\n    padding: 15px;\r\n    display: block;\r\n    position: relative;\r\n}\r\n.small-popup-title{\r\n    display: block;\r\n    height: 35px;\r\n    background: #4DBE9D;\r\n    border-radius: 5px;\r\n}\r\n.small-popup-title-span{\r\n    float: left;\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    line-height: 35px;\r\n}\r\n/* END SMALL POPUP ALERT */\r\n.loading-overlay {\r\n    position: fixed;\r\n    width: 100%;\r\n    top: 0px;\r\n    margin: 0px;\r\n    min-height: 200px;\r\n    height: 100%;\r\n    background-color: #000;\r\n    z-index: 1004;\r\n    opacity: 0.4;\r\n}\r\n.loading-image {\r\n    position: fixed;\r\n    left: 50%;\r\n    top: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    -moz-transform: translate(-50%, -50%);\r\n    -webkit-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    width: 60px;\r\n    height: 60px;\r\n    z-index: 1005;\r\n}\r\n.loading-text {\r\n    position: absolute;\r\n    bottom: 11px;\r\n    width: 100%;\r\n    text-align: center;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n}\r\n.loading-overlay-total-sales {\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 0px;\r\n    margin: 0px;\r\n    min-height: 200px;\r\n    height: 100%;\r\n    background-color: #000;\r\n    z-index: 1;\r\n    opacity: 0.4;\r\n    border-radius: 0px 0px 6px 6px;\r\n}\r\n.loading-image-total-sales {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    -ms-transform: translate(-50%, -50%);\r\n    -moz-transform: translate(-50%, -50%);\r\n    -webkit-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    width: 60px;\r\n    height: 60px;\r\n    z-index: 2;\r\n}\r\n.head-link-is-favourite{\r\n    color: #0070BA;\r\n}\r\n.head-link-is-not-favourite{\r\n    color: #000;\r\n}\r\n.link-is-favourite{\r\n    color: #0070BA;\r\n}\r\n.link-is-not-favourite{\r\n    color: #535c69;\r\n}\r\n.warning-required-filter-search{\r\n    margin-left: 10px;\r\n    font-size: 12px;\r\n    color: red;\r\n}\r\n.select-page-report{\r\n    color: #0070BA;\r\n    font-size: 12px;\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n}\r\n.select-page-text{\r\n    color: #0070BA;\r\n    font-size: 11px;\r\n    text-decoration: none;\r\n    font-weight: bold;\r\n}\r\n.select-page-arrow {\r\n    border: solid #0070BA;\r\n    border-width: 0 2px 2px 0;\r\n    display: inline-block;\r\n    padding: 3px;\r\n    width: 1px;\r\n    height: 1px;\r\n}\r\n.select-page-arrow-right {\r\n    transform: rotate(-45deg);\r\n    -webkit-transform: rotate(-45deg);\r\n}\r\n.select-page-arrow-left {\r\n    transform: rotate(135deg);\r\n    -webkit-transform: rotate(135deg);\r\n}\r\n.select-page-arrow-up {\r\n    transform: rotate(-135deg);\r\n    -webkit-transform: rotate(-135deg);\r\n}\r\n.select-page-arrow-down {\r\n    border: solid #7c7373;\r\n    border-width: 0 2px 2px 0;\r\n    display: inline-block;\r\n    padding: 3px;\r\n    transform: rotate(45deg);\r\n    -webkit-transform: rotate(45deg);\r\n}\r\n.li-option-select-row{\r\n    background-color: #fff;\r\n}\r\n.li-option-select-row:hover{\r\n    background-color: #f5f5f5;\r\n}\r\n.tb-admin-report{\r\n    border: 0px solid #ddd;\r\n}\r\n.tb-admin-report th{\r\n    border: 1px solid #ddd;\r\n    padding: 8px 8px;\r\n    font-weight: bold;\r\n    background: #ddd;\r\n    min-width: 50px;\r\n    font-size: 12px;\r\n}\r\n.tb-admin-report td{\r\n    font-size: 12px;\r\n    padding: 10px 15px;\r\n    border: 1px solid #ddd;\r\n}\r\n.box-suggest{\r\n    width: 250px;\r\n    border: 1px solid #adaaaa;\r\n    position: relative;\r\n    margin-left: 28px;\r\n    margin-right: 20px;\r\n    margin-top: 25px;\r\n    float: left;\r\n}\r\n.readmore-suggest, .hidden-suggest{\r\n    color: #1f95e2;\r\n}\r\n.readmore-report, .hidden-report{\r\n    color: #1f95e2;\r\n}\r\n.slidebar-widget{\r\n    float: left;\r\n    width: 100%;\r\n    background: #fff;\r\n}\r\n.slidebar-widget-top{\r\n    margin-bottom: 10px;\r\n    position: relative;\r\n}\r\n.slidebar-widget-top-title{\r\n    color: #fff;\r\n    font-family: \\\"OpenSans-Bold\\\", sans-serif;\r\n    font-size: 12px;\r\n    height: 40px;\r\n    line-height: 40px;\r\n    padding-left: 20px;\r\n    text-transform: uppercase;\r\n    font-weight: bold;\r\n}\r\n.slidebar-widget-top-add{\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 9px;\r\n    font-size: 17px;\r\n}\r\n.slidebar-widget-content{\r\n    display: block;\r\n}\r\n.slidebar-widget-item{\r\n    border-bottom: none;\r\n    display: block;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    margin-bottom: 3px;\r\n    overflow: hidden;\r\n    padding: 8px 0 8px 17px;\r\n}\r\n.inside-sub-menu-report a{\r\n    text-decoration: none;\r\n    display: block;\r\n    font-size: 14px;\r\n    color: #8a8f96;\r\n}\r\n::-webkit-scrollbar {\r\n    width: 12px;\r\n    cursor: pointer;\r\n    height: 12px;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n    background: rgba(0, 0, 0, 0.5);\r\n    border-radius: 4px;\r\n}\r\n.text-red{\r\n    color: #ff0000;\r\n}\r\n.group-list-search-report{\r\n    list-style: none outside none;\r\n    margin: 0px 0px;\r\n    padding: 0;\r\n    position: relative;\r\n    -webkit-column-break-inside: avoid;\r\n    page-break-inside: avoid;\r\n    break-inside: avoid-column;\r\n    max-width: 300px;\r\n    width: 300px;\r\n    display: inline-table;\r\n}\r\n.select-filter{\r\n    background-color: #fff;\r\n    color: #000;\r\n}\r\n.inp-disable{\r\n    background-color: #e8e8e0;\r\n    color: #5f5a5a;\r\n}\r\n.inp-link-disable{\r\n    display: none;\r\n}\r\n.dropup-btn {\r\n    background-color: #fff;\r\n    color: #665757;\r\n    padding: 9px 14px;\r\n    font-size: 13px;\r\n    border: none;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.dropup {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.dropup-content {\r\n    display: none;\r\n    position: absolute;\r\n    background-color: #fff;\r\n    min-width: 160px;\r\n    bottom: 50px;\r\n    z-index: 1;\r\n    box-shadow: -1px 4px 6px 2px #ddd;\r\n}\r\n\r\n.dropup-content a {\r\n    color: black;\r\n    padding: 12px 16px;\r\n    text-decoration: none;\r\n    display: block;\r\n    font-size: 12px;\r\n}\r\n\r\n.dropup-content a:hover {\r\n    background-color: #fafafa;\r\n}\r\n\r\n/*.dropup:hover .dropup-content {\r\n    display: block;\r\n}*/\r\n\r\n/*.dropup:hover .dropup-btn {\r\n    border: 1px solid #000;\r\n    color: #000;\r\n}*/\r\n.circle{\r\n    border: 2px solid #fff;\r\n    width: 18px;\r\n    height: 18px;\r\n    border-radius: 100%;\r\n    position: relative;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    background: none;\r\n}\r\n.circle:hover{\r\n    background: #fff;\r\n}\r\n.circle:active{\r\n    background: #fff;\r\n}\r\n.circle:before,\r\n.circle:after{\r\n    content:'';position:absolute;top:0;left:0;right:0;bottom:0;\r\n}\r\n/* PLUS */\r\n.circle.plus:before,\r\n.circle.plus:after {\r\n    background: #fff;\r\n}\r\n.circle.plus:hover::before,\r\n.circle.plus:hover::after {\r\n    background: #2fc7f7;\r\n}\r\n.circle.plus:before{\r\n    width: 2px;\r\n    margin: 3px auto;\r\n}\r\n.circle.plus:after{\r\n    margin: auto 3px;\r\n    height: 2px;\r\n    box-shadow: none;\r\n}\r\n.percentdiff-up{\r\n    color: #009900;\r\n}\r\n.percentdiff-down{\r\n    color: #ff0000;\r\n}\r\n.hidden{\r\n    display: none;\r\n}\r\n.tb-report{\r\n    border: 1px solid #ddf;\r\n}\r\n.tb-report th{\r\n    border: 1px solid #ddf;\r\n    padding: 5px 3px;\r\n    font-weight: bold;\r\n    background: #DCE6F1;\r\n    min-width: 50px;\r\n    font-size: 12px;\r\n}\r\n.tb-report td{\r\n    border: 1px solid #ddf;\r\n    padding: 5px 3px;\r\n}\r\n/* The container */\r\n.checkbox-container {\r\n    float: left;\r\n    position: relative;\r\n    padding-left: 25px;\r\n    margin-bottom: 12px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    line-height: 19px;\r\n  }\r\n/* Hide the browser's default checkbox */\r\n.checkbox-container input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n    height: 0;\r\n    width: 0;\r\n  }\r\n  \r\n  /* Create a custom checkbox */\r\n  .checkmark {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 16px;\r\n    width: 16px;\r\n    background-color: #f1f1f1;\r\n    border: 1px solid #8e8a8a;\r\n  }\r\n  \r\n  /* On mouse-over, add a grey background color */\r\n  .checkbox-container:hover input ~ .checkmark {\r\n    background-color: #ccc;\r\n  }\r\n  \r\n  /* When the checkbox is checked, add a blue background */\r\n  .checkbox-container input:checked ~ .checkmark {\r\n    background-color: #4DBE9D/*#2196F3*/;\r\n    border: 1px solid #fff;\r\n  }\r\n  \r\n  /* Create the checkmark/indicator (hidden when not checked) */\r\n  .checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n  }\r\n  \r\n  /* Show the checkmark when checked */\r\n  .checkbox-container input:checked ~ .checkmark:after {\r\n    display: block;\r\n  }\r\n  \r\n  /* Style the checkmark/indicator */\r\n  .checkbox-container .checkmark:after {\r\n    left: 5px;\r\n    top: 1px;\r\n    width: 3px;\r\n    height: 9px;\r\n    border: solid white;\r\n    border-width: 0 3px 3px 0;\r\n    -webkit-transform: rotate(45deg);\r\n    -ms-transform: rotate(45deg);\r\n    transform: rotate(45deg);\r\n  }\r\n\r\n  input:focus {\r\n    outline:none;\r\n    border: 1px solid red;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
